import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  Headline,
  ZusammenfassungPartner,
  SummingUp,
  SpeicherButton, useNextPage,
  PrevNextButton,
  useGotoPage,
  actions,
} from 'ion-lib';
import { Col, Row } from 'react-bootstrap';
import i18next from 'i18next';
import versicherungspakete from '../../components/Versicherungspaket';
import { getBannerFileName } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Zusammenfassung = () => {
  const gotoPage = useGotoPage();
  const nextPage = useNextPage();
  const daten = useSelector((state) => state.daten);
  const dispatch = useDispatch();
  const versicherungspaket = versicherungspakete(daten, gotoPage);

  const handleNextClick = () => {
    dispatch(actions.updateByList({
      'appDaten.dokumente.antrag': false,
      'appDaten.dokumente.beratung': false,
      'appDaten.dokumente.geladen': false,
    }));
    nextPage();
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <Headline>Bitte prüfen Sie Ihre Angaben</Headline>
          <ZusammenfassungPartner />
          <Accordion data={versicherungspaket} className="mb-5" />
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              nextProps={{
                text: i18next.t('zusammenfassung.weiter'),
              }}
              onNextClick={handleNextClick}
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>

      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb />
      </SummingUp>
    </Row>
  );
};

export default Zusammenfassung;
